angular.module('config').service('tgClock', function ($http, tgConfig, $interval, $location) {
	// console.log('tgClock');
	this.dbDateTz = 'America/Sao_Paulo'
	var _clock = {
		now: moment.utc(),
		latestServerTimestamp: null,
	}
	var _nowIntervalPromise = null,
		_latestUpdateTimestamp = null

	$http.defaults.headers.common.apptoken = tgConfig.apptoken
	var _httpConfig = {
		method: 'GET',
		url: tgConfig.api + '/time'
	}
	_httpConfig.url = _httpConfig.url.replace('http', $location.protocol())

	function _init() {
		$http(_httpConfig)
			.then(function (data) {
				var latestServerTimestamp = moment.utc(data.data.now)
				var latestUpdateTimestamp = moment.utc()

				if (_nowIntervalPromise) {
					$interval.cancel(_nowIntervalPromise)
					_nowIntervalPromise = null
				}

				_clock.now = moment
					.utc(latestServerTimestamp)
					.add(moment.duration(moment.utc() - latestUpdateTimestamp))
				_clock.latestServerTimestamp = latestServerTimestamp
				_latestUpdateTimestamp = latestUpdateTimestamp
				_nowIntervalPromise = $interval(function () {
					// console.log('$interval clock');
					_clock.now = moment
						.utc(_clock.latestServerTimestamp)
						.add(moment.duration(moment.utc() - _latestUpdateTimestamp))
				}, 1000)
			})
			.catch(function (err) {
				var myErr = new Error('Erro ao buscar data atual do servidor!')
				myErr.innerErr = err
				throw myErr
			})
	}

	_init()

	// $interval(function () {
	//     _init();
	// }, 300000);

	this.getClock = function () {
		return _clock
	}
})
